"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeElements = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var AttributeElementsDefaultChildren_1 = require("./AttributeElementsDefaultChildren");
var AttributeElementsCore = /** @class */ (function (_super) {
    tslib_1.__extends(AttributeElementsCore, _super);
    function AttributeElementsCore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            validElements: null,
            isLoading: true,
            error: null,
        };
        _this.lastRequestedConfigHash = "";
        _this.getLoadingConfigHash = function (props) {
            return json_stable_stringify_1.default({
                workspace: props.workspace,
                displayForm: props.displayForm,
                offset: props.offset,
                limit: props.limit,
                options: props.options,
                filters: props.filters,
            });
        };
        _this.getBackend = function () {
            return _this.props.backend.withTelemetry("AttributeElements", _this.props);
        };
        _this.loadMore = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var moreItems_1, error_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // do not execute while still loading
                        if (this.state.isLoading) {
                            return [2 /*return*/];
                        }
                        this.setState({ isLoading: true, error: null });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.state.validElements.next()];
                    case 2:
                        moreItems_1 = _a.sent();
                        this.setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { isLoading: false, validElements: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, state.validElements), moreItems_1), { items: tslib_1.__spreadArrays(state.validElements.items, moreItems_1.items) }) })); });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setState({ isLoading: false, error: error_1 });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.getValidElements = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, workspace, options, displayForm, offset, limit, filters, configHash, elements, error_2;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.props, workspace = _a.workspace, options = _a.options, displayForm = _a.displayForm, offset = _a.offset, limit = _a.limit, filters = _a.filters;
                        this.setState({ isLoading: true, error: null });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        configHash = this.getLoadingConfigHash(this.props);
                        this.lastRequestedConfigHash = configHash;
                        return [4 /*yield*/, this.getBackend()
                                .workspace(workspace)
                                .attributes()
                                .elements()
                                .forDisplayForm(displayForm)
                                .withOffset(offset || 0)
                                .withLimit(limit || 50)
                                .withOptions(options)
                                .withAttributeFilters(filters !== null && filters !== void 0 ? filters : [])
                                .query()];
                    case 2:
                        elements = _b.sent();
                        // only set the result if the data is still relevant
                        if (this.lastRequestedConfigHash === configHash) {
                            this.setState({ validElements: elements, isLoading: false });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        this.setState({ isLoading: false, error: error_2 });
                        this.props.onError(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    AttributeElementsCore.prototype.componentDidMount = function () {
        this.getValidElements();
    };
    AttributeElementsCore.prototype.componentDidUpdate = function (prevProps) {
        var needsInvalidation = !sdk_model_1.areObjRefsEqual(this.props.displayForm, prevProps.displayForm) ||
            !isEqual_1.default(this.props.filters, prevProps.filters) ||
            this.props.workspace !== prevProps.workspace ||
            !isEqual_1.default(this.props.options, prevProps.options);
        if (needsInvalidation) {
            this.getValidElements();
        }
    };
    AttributeElementsCore.prototype.render = function () {
        var _a = this.state, validElements = _a.validElements, isLoading = _a.isLoading, error = _a.error;
        return this.props.children({
            validElements: validElements,
            loadMore: this.loadMore,
            isLoading: isLoading,
            error: error,
        });
    };
    AttributeElementsCore.defaultProps = {
        options: {},
        children: AttributeElementsDefaultChildren_1.AttributeElementsDefaultChildren,
        onError: sdk_ui_1.defaultErrorHandler,
    };
    return AttributeElementsCore;
}(react_1.default.PureComponent));
/**
 * AttributeElements is a component that lists attribute values using a children function
 *
 * @public
 */
exports.AttributeElements = sdk_ui_1.withContexts(AttributeElementsCore);
//# sourceMappingURL=AttributeElements.js.map